import { Component, OnInit, Input, ViewEncapsulation } from "@angular/core";
import { User } from "../../../../models";

@Component({
  selector: "del-account-auth-modal",
  templateUrl: "./del-account-auth-modal.component.html",
  styleUrls: [
    "./del-account-auth-modal.component.scss",
    "../../../../../../assets/icon/icofont/css/icofont.scss",
  ],
  encapsulation: ViewEncapsulation.None,
})
export class DelAccountAuthModal implements OnInit {
  @Input() currentUser: User;
  @Input() dialogClass: string;
  @Input() hideHeader = false;
  @Input() hideFooter = false;
  public visible = false;
  public visibleAnimate = false;

  constructor() {}

  ngOnInit() {}

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains("modal")) {
      this.hide();
    }
  }
}
